import { render, staticRenderFns } from "./physiotherapy.vue?vue&type=template&id=7de00849&"
import script from "./physiotherapy.vue?vue&type=script&lang=js&"
export * from "./physiotherapy.vue?vue&type=script&lang=js&"
import style0 from "./physiotherapy.vue?vue&type=style&index=0&id=7de00849&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports